/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type PGATourBuildModelInput = {|
  modelId: string,
  clientMutationId?: ?string,
|};
export type PGAModelBuilderInputConfigBuildModelMutationVariables = {|
  input: PGATourBuildModelInput
|};
export type PGAModelBuilderInputConfigBuildModelMutationResponse = {|
  +pgaTourBuildModel: ?{|
    +success: ?boolean
  |}
|};
export type PGAModelBuilderInputConfigBuildModelMutation = {|
  variables: PGAModelBuilderInputConfigBuildModelMutationVariables,
  response: PGAModelBuilderInputConfigBuildModelMutationResponse,
|};
*/


/*
mutation PGAModelBuilderInputConfigBuildModelMutation(
  $input: PGATourBuildModelInput!
) {
  pgaTourBuildModel(input: $input) {
    success
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "PGATourBuildModelPayload",
    "kind": "LinkedField",
    "name": "pgaTourBuildModel",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PGAModelBuilderInputConfigBuildModelMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PGAModelBuilderInputConfigBuildModelMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "914190a9c42d210fa1469d0a1ad05b0e",
    "id": null,
    "metadata": {},
    "name": "PGAModelBuilderInputConfigBuildModelMutation",
    "operationKind": "mutation",
    "text": "mutation PGAModelBuilderInputConfigBuildModelMutation(\n  $input: PGATourBuildModelInput!\n) {\n  pgaTourBuildModel(input: $input) {\n    success\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '1cc7d13cfbd4ce9448af5f5b337a1aae';

module.exports = node;
